import { AppState } from "../../../redux-configuration/AppState";
import { Conversation } from "../../domain/entities/conversation";

export const businessConversationsSelector = (appState: AppState): Conversation[] | null => appState.messaging.conversation.data
export const loadingBusinessConversationsSelector = (appState: AppState): boolean => appState.messaging.conversation.loading
export const errorLoadBusinessConversationsSelector = (appState: AppState): string | undefined => appState.messaging.conversation.error
